function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCartAdd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 114 114",
    style: {
      enableBackground: "new 0 0 114 114",
      width: "100%"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E61673"
    },
    points: "55.9,43.1 45.3,32.5 43.1,34.7 55.9,47.4 68.6,34.7 66.4,32.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E61673"
    },
    points: "55.9,32.2 45.3,21.6 43.1,23.8 55.9,36.5 68.6,23.8 66.4,21.6  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      stroke: "#E61673",
      strokeWidth: 3,
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: "35.6,60.2  76.1,60.2 68.5,79.7 41.3,79.7 "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#E61673",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 81.6,55.8 78.7,53.4 76.1,60.2 "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#E61673",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 37.3,65.9 73.9,65.9 70.7,74.1 39.7,74.1 "
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#E61673"
    },
    cx: 46.3,
    cy: 86.3,
    r: 4.4
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#E61673"
    },
    cx: 64.8,
    cy: 86.3,
    r: 4.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E61673"
    },
    d: "M56.5,8.7c26.5,0,48,21.5,48,48s-21.5,48-48,48s-48-21.5-48-48S30,8.7,56.5,8.7 M56.5,0.7 c-30.9,0-56,25.1-56,56s25.1,56,56,56s56-25.1,56-56S87.4,0.7,56.5,0.7L56.5,0.7z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartAdd);
export default __webpack_public_path__ + "static/media/cartAdd.1d9c43f1.svg";
export { ForwardRef as ReactComponent };